import React, { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || '';

let scriptLoaded = false;
function ensureAdSenseScript() {
  if (scriptLoaded || !ADSENSE_CLIENT) return;
  if (document.querySelector('script[data-vd-adsense]')) {
    scriptLoaded = true;
    return;
  }
  const s = document.createElement('script');
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  s.async = true;
  s.crossOrigin = 'anonymous';
  s.setAttribute('data-vd-adsense', '1');
  document.head.appendChild(s);
  scriptLoaded = true;
}

/**
 * AdSlot — renders a Google AdSense slot when:
 *  - REACT_APP_ADSENSE_CLIENT env is set
 *  - User is NOT on Pro plan
 * Otherwise renders nothing (so layouts stay clean).
 *
 * @param {string} slot AdSense slot ID
 * @param {string} format 'auto' | 'horizontal' | 'rectangle' etc.
 * @param {string} className extra wrapper classes
 */
export default function AdSlot({ slot, format = 'auto', className = '', testId = 'ad-slot' }) {
  const { user } = useAuth();
  const ref = useRef(null);

  const isPro = user && typeof user === 'object' && user.plan === 'pro';
  const enabled = Boolean(ADSENSE_CLIENT) && !isPro;

  useEffect(() => {
    if (!enabled) return;
    ensureAdSenseScript();
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // ignore
    }
  }, [enabled]);

  if (!enabled) {
    // In development we can show a placeholder; in production keep silent
    if (process.env.NODE_ENV === 'development' && !isPro) {
      return (
        <div
          data-testid={`${testId}-placeholder`}
          className={`bg-vault-paper/30 border border-dashed border-white/10 rounded-lg p-4 text-center text-xs text-gray-500 font-mono tracking-wider ${className}`}
        >
          AD SLOT · {slot} · set REACT_APP_ADSENSE_CLIENT to activate
        </div>
      );
    }
    return null;
  }

  return (
    <div data-testid={testId} className={className}>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
